<section class="client-management">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb [title3]="'ORDERMANAGEMENT.SellingCatalogMenu'">
        </app-breadcrumb>
      </div>
      <div class="col-md-12">
        <div class="common-tabbing">
          <div class="table-content box-style company-info">
            <div class="table-heading">
              <h3 style="font-weight: 600">{{'ORDERMANAGEMENT.SellingCatalogMenu'| translate}}
                <span (click)="onRefreshTable()" class="refresh-btn"
                  matTooltip="Refresh"><mat-icon>autorenew</mat-icon></span>
              </h3>
              <div class="search-form-wrapper">
                <div class="search-form">
                  <mat-icon matPrefix class="material-icons search">search</mat-icon>
                  <input (keyup)="onKeyUp($event)" #searchBox [(ngModel)]="search" mat-input
                    placeholder="{{'ORDERMANAGEMENT.SearchCatalog'| translate}}" />
                  <mat-icon *ngIf="this.search !== '' " class="material-icons clear"
                    (click)="resetSearch()">clear</mat-icon>
                </div>
                <!-- <button  class="btn-style" routerLink="add-edit-selling-catalog">
                  <span class="material-icons">add</span>{{'ORDERMANAGEMENT.Add_Catalog'| translate}}
                </button>
                <button  [matMenuTriggerFor]="menu" class="btn-style menu-btn">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item >
                    <span>{{'GENERAL.Delete' | translate}}</span>
                  </button>
                </mat-menu> -->
              </div>
            </div>
            <div class="table-wrapper resource-color-table">
              <table #table
                [dataSource]="ServiceCatalogList | paginate: {itemsPerPage: this.itemsPerPage, currentPage: this.page, totalItems: this.totalItems }"
                mat-table style="width: 100%">
  
                <!-- <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef style="width: 80px;">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row" style="width: 80px;">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                  </td>
                </ng-container> -->
  
                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef style="width: 100px;">
                    {{'TABLE.Action' | translate}}
                  </th>
                  <td mat-cell *matCellDef="let element; let i = index" style="width: 100px;">
                    <div class="button-view table-heading">
                      <button class="btn-style" (click)="viewDetails(element)">
                        {{'ORDERMANAGEMENT.ViewLabel' | translate}}
                      </button>
                      <!-- <button class="btn-style"(click)="viewDetails(element)">View</button> -->
                      <button class="btn-style" (click)="redirectToOrder(element)">
                        {{'ORDERMANAGEMENT.MANAGEORDERS.AddOrder'| translate}}
                    </button>
                    </div>
                   
                    <!-- <app-wheel-action (click)="viewDetails(element)" [viewOn]="true" [icons]="'one'"[element]="element"></app-wheel-action> -->
                  </td>
                </ng-container>
  
                <ng-container matColumnDef="codeId">
                  <th (click)="changeSorting('codeId',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{'ORDERMANAGEMENT.CODE_ID'| translate}} <span
                      [ngClass]="{'down': sortKey === 'codeId' && sortBy === '-1' , 'up': sortKey === 'codeId' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: nowrap">{{element.codeId ? element.codeId :
                    '-'}}</td>
                </ng-container>
                <ng-container matColumnDef="sellingCatalogName">
                  <th (click)="changeSorting('sellingCatalogName',sortBy)" *matHeaderCellDef class="short-arrow"
                    mat-header-cell>
                    {{'ORDERMANAGEMENT.CatalogName'| translate}} <span
                      [ngClass]="{'down': sortKey === 'sellingCatalogName' && sortBy === '-1' , 'up': sortKey === 'sellingCatalogName' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform: capitalize;">
                    {{element.sellingCatalogName ? element.sellingCatalogName : '-'}}</td>
                </ng-container>
                <!-- <ng-container matColumnDef="CatalogFor">
                  <th (click)="changeSorting('CatalogFor',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{ 'ORDERMANAGEMENT.CatalogFor' | translate }} <span
                      [ngClass]="{'down': sortKey === 'CatalogFor' && sortBy === '-1' , 'up': sortKey === 'CatalogFor' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: break-spaces;text-transform: capitalize;">
                    {{element?.sellingCatalogFor == 1 ? 'Public' : 'Customer'}}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th (click)="changeSorting('status',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell
                    style="min-width:200px;">
                    {{'ORDERMANAGEMENT.STATUS'| translate}}
                  </th>
                  <td mat-cell *matCellDef="let element" class="status-text" style="white-space: pre-line;min-width: 200px;">{{element.status
                    ? element.status : '-'}}</td>
                </ng-container> -->
                <ng-container matColumnDef="createdAt">
                  <th (click)="changeSorting('createdAt',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{'ORDERMANAGEMENT.CREATED_DATE'| translate}} <span
                      [ngClass]="{'down': sortKey === 'createdAt' && sortBy === '-1' , 'up': sortKey === 'createdAt' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: nowrap;text-transform: capitalize;">{{
                    (element.createdAt | date : 'dd/MM/yyyy HH:mm') ? (element.createdAt | date : 'dd/MM/yyyy HH:mm') :
                    '-'}}</td>
                </ng-container>
  
                <!-- <ng-container matColumnDef="updatedAt">
                  <th (click)="changeSorting('updatedAt',sortBy)" *matHeaderCellDef class="short-arrow" mat-header-cell>
                    {{'Procurement_Management.UpdatedOn' | translate}} <span
                      [ngClass]="{'down': sortKey === 'updatedAt' && sortBy === '-1' , 'up': sortKey === 'updatedAt' && sortBy === '1'}">
                      <img alt="" src="assets/images/up-arrow.svg"></span>
                  </th>
                  <td mat-cell *matCellDef="let element" style="white-space: nowrap;text-transform: capitalize;">{{
                    (element.updatedAt | date : 'dd/MM/yyyy HH:mm') ? (element.updatedAt | date : 'dd/MM/yyyy HH:mm') :
                    '-'}}</td>
                </ng-container> -->
  
  
  
                <tr mat-header-row *matHeaderRowDef="RFQDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: RFQDisplayedColumns"></tr>
              </table>
            </div>
  
            <app-pagination [noRecordFound]="noRecordFound" [itemsPerPage]="itemsPerPage" [page]="page"
              (pageChange)="pageChanged($event)" (changeItem)="changeItemsPerPage($event)"
              [totalItems]="totalItems"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>